import { render } from "./DocumentMarkdown.vue?vue&type=template&id=6cfb4bca&scoped=true&bindings={\"text\":\"props\",\"showContent\":\"data\",\"currentContext\":\"data\",\"currentVersion\":\"data\",\"currentDocument\":\"data\",\"showContentAndMenu\":\"options\"}"
import script from "./DocumentMarkdown.vue?vue&type=script&lang=js"
export * from "./DocumentMarkdown.vue?vue&type=script&lang=js"

import "./DocumentMarkdown.vue?vue&type=style&index=0&id=6cfb4bca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cfb4bca"

export default script